import React from 'react'
// import { 
//     makeStyles, 
// } from '@material-ui/core'

// const styles = makeStyles({
//     tableContainer: {
//         position: 'relative'
//     },
//     candidateHead: {
//         display: 'flex', 
//         padding: '20px 0px 10px 0px', 
//         fontSize: 18,
//         '& #headName': {
//             width: '60%'
//         }, 
//         '& #headVotes, #headPercent': {
//             width: '20%', 
//             textAlign: 'right', 
//             padding: 10

//         }
//     },  
//     candidateRow: {
//         display: 'flex',
//         width: '100%',
//         position: 'relative',
//         alignItems: 'center', 
//         padding: '10px 0px 30px 0px',
//         borderTop: '1px dotted #aaa', 
//         '& #bodyVotes, #bodyPercent': {
//             width: '20%', 
//             padding: 10

//         }
//     }, 
//     nameCell: {
//         width: '60%',
//         '& #isElected': {
//             top: -2, 
//             fontSize: 16
//         }, 
//         '& #isElected': {
//             fontFamily: 'proxima-nova-bold', 
//             textTransform: 'uppercase', 
//             fontSize: 14,
//         },
//         '& #name': {
//             fontSize: 20, 
//             padding: '5px 0px'
//         },
//         '& #voteBar': {
//             width: '100%',
//             position: 'absolute',
//             height: 15, 
//         }, 
//         "& #party": {
//             fontWeight: 600, 
//             paddingBottom: 5
//         }
//     }
// })

export default function ResultsTable({results}) {

    return (
        <div id="resultsTable" className={'classes.tableContainer px-1'}>
            <div className={'classes.candidateHead pt-5 pb-3 grid text-lg  text-right gap-2'} style={{gridTemplateColumns:'3fr 1fr 1fr'}}>
                <div id="headName" className="col-span-1"> </div>
                <div id="headVotes">Votes</div>
                <div id="headPercent">Percent</div>
            </div>
            <div className={'classes.candidateBody '}>
                {results.choice && results.choice.map(candidate=> {
                    return (
                        <div key={candidate.id} className={'classes.candidateRow relative grid border-t border-gBlack border-opacity-40 border-dotted pt-2 pb-6 text-lg gap-2'} style={{gridTemplateColumns:'3fr 1fr 1fr'}}>
                            <div className={'classes.nameCell'}>
                                <div className="text-sm font-semibold uppercase" style={{color: (candidate.elected || candidate.acclaimed) ? '#005EB8' : '#252525'}}>
                                    {candidate.acclaimed ? <span><i class="fa fa-check" aria-hidden="true"></i> Acclaimed</span>: (candidate.elected ? <span><i class="fa fa-check" aria-hidden="true"></i> Elected</span> : '')} {candidate.incumbent && 'incumbent'}
                                </div>
                                <div className="py-1">{candidate.name2} </div>
                                {candidate.party.name && <div className='text-base font-medium pb-1'>{candidate.party.name}</div>}
                                <div id="voteBar" className='h-4 absolute w-[95%]'>
                                    <div className="h-full bg-gRed" style={{width: `${candidate.votes.votePercent}%`}}/>
                                </div>
                            </div>
                            <div id="bodyVotes" className={'self-center font-medium text-right'}>{candidate.votes.total.toLocaleString('en')}</div>
                            <div id="bodyPercent" className={'self-center font-medium text-right'} >{candidate.votes.votePercent}%</div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
